<template>
    <Dialog
        :visible="showModal"
        :modal="true"
        :closable="false"
        class="sms-preview-modal p-dialog-share px-3"
    >
        <template #header>
            <h3 :class="appendSehattyClass('title')">معاينة رسالة التبرع</h3>
        </template>
        <div class="text-center">
            <img :src="previewImageLink" alt="SMS Preview" class="responsive-image"/>
        </div>
        <div class="text-center mt-4">
            <button
                id="close-btn"
                :class="appendSehattyClass('btn btn-primary btn-lg rounded-5 px-5 text-white')"
                type="button"
                @click.prevent="close"
            >
                إغلاق
            </button>
        </div>
    </Dialog>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';
import { appendSehattyClass } from '@/helpers/helpers';
const props = defineProps({
  showModal: Boolean,
  previewImageLink: String
});

const emit = defineEmits(['close']);

function close() {
  emit('close');
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
.title{
    &.sehatty{
        color: $color-text-sehatty;
    }
}
.btn-primary {
    &.sehatty{
        background-color: $color-primary-sehatty;
        border-color: $color-primary-sehatty;;
        color: $color-background-sehatty;
         &:hover {
            background-color: darken($color-primary-sehatty, 10%);
        }
    }
}
.responsive-image {
    max-width: 100%;
    max-height: 60vh;
    object-fit: contain;
}
</style>